import React from "react"

export default props => (
    
    <div className="column is-3">
        <a href={props.website} target="_blank" rel="noopener noreferrer"><img data-src={props.imgSrc} className="lazyload" alt={props.altText}/></a>
    </div>
)

